import areaCascader from "./main.vue"

/* istanbul ignore next */
areaCascader.install = function(Vue) {
  Vue.component(areaCascader.name, areaCascader)
}

export default areaCascader
